import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  OnInit,
  Optional,
} from '@angular/core';
import { IconSize } from '@psei/ng/api';
import { pseicToasterAnimation } from '../pseic-toaster-animation';
import {
  ToasterMessageData,
  ToasterMessageType,
  TOASTER_AUTOCLOSE_FLAG,
  TOASTER_CONTAINER_DATA,
  TOASTER_DEFAULT_AUTOCLOSE as TOASTER_DEFAULT_AUTOCLOSE_TIME
} from '../pseic-toaster-ref';

@Component({
  selector: 'pseic-toaster',
  templateUrl: './pseic-toaster.component.html',
  styleUrls: ['./pseic-toaster.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    pseicToasterAnimation
  ]
})
export class PseicToasterComponent implements OnInit {

  iconSize = IconSize.Small;
  typeIconSize = IconSize.Medium;

  defaultCloseTimeInMs = 30000;

  @HostBinding('@pseicToasterAnimation') public pseicToasterAnimation = true;

  @HostBinding('class.pseic-toaster') readonly classPseicToaster = true;

  message = '';
  messageType: ToasterMessageType = 'message';

  iconName: 'emoji-smile' | 'emoji-neutral' | 'emoji-sad' = 'emoji-smile';

  constructor(
    @Inject(TOASTER_CONTAINER_DATA) public componentData: ToasterMessageData,
    @Optional() @Inject(TOASTER_DEFAULT_AUTOCLOSE_TIME) public autocloseTimeInMs: number,
    @Optional() @Inject(TOASTER_AUTOCLOSE_FLAG) public autoCloseFlag: boolean
) { }

  ngOnInit(): void {
    this.message = this.componentData.message;
    this.messageType = this.componentData.messageType;
    this.switchType();
  }

  closeComponent(): void {
    this.componentData?.overlayRef?.detach();
  }

  private switchType(): void {
    switch (this.messageType) {
      case 'error':
        this.iconName = 'emoji-sad';
        break;
      case 'warning':
        this.iconName = 'emoji-neutral';
        break;
      default:
        this.iconName = 'emoji-smile';
    }
    if (this.autoCloseFlag) {
      setTimeout(() => {
        this.componentData?.overlayRef?.detach()
      }, this.autocloseTimeInMs || this.defaultCloseTimeInMs);
    }
  }

}
